<template>
  <div id="home">

  </div>
</template>

<script>
// http://farmbook.com/API/listProduct

export default {
  name: 'CallbackLogin',
  components: {

  },
  data () {
    return {
      type: null
    }
  },
  methods: {},
  mounted () {
    this.type = this.$route.params.type
    console.log('this.type', this.type)
    if (this.type === 'farmer') {
      this.$router.push({ name: 'AddGarden' })
    } else if (this.type === 'packager') {
      this.$router.push({ name: 'AddStore', params: {type: this.type} })
    } else if (this.type === 'retailer') {
      this.$router.push({ name: 'AddStore', params: {type: this.type} })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/CallBackLogin.vue